import { Typography } from "@mui/material";

const DomesticMarketMonthlyStockSalesFavoriteCard = ({ favorite }) => {
  return (
    <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
      {favorite.producer_name}
    </Typography>
  );
};

export default DomesticMarketMonthlyStockSalesFavoriteCard;
